import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { promptTemplateApi } from "@/apis/promptTemplate";
import Router from "@/constants/router";
import { CreatePromptTemplateDto } from "@/dto/PromptTemplateDto";

interface FormData extends CreatePromptTemplateDto {}

/**
 * 보스베이비 프롬프트 템플릿 생성 커스텀 훅
 *
 * @description 보스베이비 채팅 프롬프트 템플릿 생성 비즈니스 로직을 관리하는 훅
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export default function useBossBabyCreatePromptTemplate() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const form = useForm<FormData>({
    defaultValues: {
      templateKey: "boss_baby_chat", // 🔥 보스베이비 채팅 프롬프트 키로 고정
      templateName: "",
      templateDescription: "",
      templateCategory: "boss_baby", // 🔥 보스베이비 카테고리로 고정
      systemPrompt: "",
      userPromptTemplate: "",
      assistantPrompt: "",
      promptVariables: null,
      aiModelProvider: "OPENAI",
      aiModelName: "gpt-4o",
      aiModelTemperature: 0.7,
      aiMaxTokens: 4000,
      aiModelConfig: null,
      useCondition: "",
      priorityOrder: 1,
    },
  });

  const handleSubmit = useCallback(async (data: FormData) => {
    setLoading(true);
    try {
      const createData: CreatePromptTemplateDto = {
        ...data,
        templateKey: "boss_baby_chat", // 🔥 강제로 boss_baby_chat으로 설정
        templateCategory: "boss_baby", // 🔥 강제로 boss_baby로 설정
        promptVariables: data.promptVariables ? JSON.parse(data.promptVariables) : null,
        aiModelConfig: data.aiModelConfig ? JSON.parse(data.aiModelConfig) : null,
      };

      await promptTemplateApi.create(createData);
      enqueueSnackbar("Boss Baby prompt template created successfully.", { variant: "success" });
      navigate(Router.BossBabyPromptTemplate);
    } catch (error: any) {
      enqueueSnackbar(error.message || "Failed to create prompt template", { variant: "error" });
    } finally {
      setLoading(false);
    }
  }, [navigate, enqueueSnackbar]);

  const handleCancel = useCallback(() => {
    navigate(Router.BossBabyPromptTemplate);
  }, [navigate]);

  return {
    form,
    loading,
    handleSubmit,
    handleCancel,
  };
}









